import styled from "styled-components";

const PartnerPanelStyled = styled.div`

`;

export default PartnerPanelStyled;